import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./plugins";
import "./filters";
import "./registerServiceWorker";

import { Notification } from "element-ui";
import AuthService from "@/services/auth.service";

Vue.config.productionTip = false;
Vue.prototype.$notify = Notification;

(async () => {
  await AuthService.handleSignInRedirect();

  const token = await AuthService.getToken();

  if (!token) {
    await AuthService.signIn();
    return;
  }

  const vue = new Vue({
    store,
    router,
    render: (h) => h(App),
  });

  vue.$mount("#app");
})();



